import PayResponse from './PayResponse';
import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import { IInitialState } from 'src/store/initialState';
import { withRouter } from 'react-router-dom';
import { errorSel, successSel } from 'src/store/modules/invoices';
import {
  creditCardActions,
  savedCreditCardsSel,
  selectedCardSel,
  creditCardErrorSel,
  creditCardSuccessSel,
  creditCardIsPendingSel
} from 'src/store/modules/creditcard';
import { userDataSel, userActions } from 'src/store/modules/user';

const mapStateToProps = (state: IInitialState) => ({
  errorPayment: errorSel(state),
  successPayment: successSel(state),
  savedCreditCards: savedCreditCardsSel(state),
  selectedCreditCard: selectedCardSel(state),
  creditCardError: creditCardErrorSel(state),
  creditCardSuccess: creditCardSuccessSel(state),
  creditCardIsPending: creditCardIsPendingSel(state),
  userData: userDataSel(state)
});

// export const pureDesktopComponent = ApplyCreditMadePayment;
export default connect(mapStateToProps)(withI18n()(withRouter(PayResponse)));
